"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var StyledTooltip_1 = require("./StyledTooltip");
var style = {
    display: 'inline-block',
    margin: '0 10px',
};
var IconWithTooltip = function (_a) {
    var Icon = _a.Icon, placement = _a.placement, text = _a.text;
    return (React.createElement("div", { style: style }, text ? (React.createElement(StyledTooltip_1.default, { Icon: Icon, text: text, placement: placement })) : (React.createElement(Icon, null))));
};
exports.default = IconWithTooltip;
//# sourceMappingURL=IconWithTooltip.js.map